import React from "react";
import {Button, Checkbox} from "antd";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {withAuthorization} from "../../services/Authorization";
import Storage from "../../services/Storage";
import CheckboxItem from "./CheckboxItem";
import LabelEncoder from "./LabelEncoder";
import _ from 'lodash';
import {SpinnerModal} from "../../public/components/SpinnerModal";

const MAX_TIRES_TO_ADD = 10;

class Tires extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      tires:{
        mainBrands: [],
        extraBrands: []
      },
      additionalTireId: 0
    };
  }

  componentDidMount() {
    this.props.dispatchFetchTires();
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.fetchTires && nextProps.fetchTires.tires ){
      const {extraBrands} = nextProps.fetchTires.tires;
      if (extraBrands && extraBrands.length >= 1) {
        const maxId = _.maxBy(extraBrands, function(b) {
          return b.id;
        });
        this.setState({additionalTireId: maxId.id + 1})
      }
      this.setState({tires: nextProps.fetchTires.tires})
    }
  }

  save = () => {
    this.props.dispatchSaveTires(this.state.tires);
  };

  onCheckboxItemChange = (name, state, category) => {
    const {tires} = this.state;
    tires[category][name] = state;
    this.setState({tires});
  };

  removeBrand = (id) => {
    const {tires} = this.state;
    tires.extraBrands = tires.extraBrands.filter(e => id !== e.id);
    this.setState({tires});
  };

  onValidateExtraBrand = (values) => {
    const {tires} = this.state;
    tires.extraBrands = tires.extraBrands || [];

    const brands = tires.extraBrands.filter(e => e.id === values.id);
    if (brands && brands.length >= 1) {
      brands[0].name = values['tires.brand'];
      this.setState({tires})
    } else {
      tires.extraBrands.push({name: values['tires.brand'], id: values.id});
      this.setState({tires, additionalTireId: this.state.additionalTireId + 1});
    }
  };

  renderExtraTires = () => {
    const {intl:{formatMessage}} = this.props;
    const {tires} = this.state;
    const user = Storage.getItem('user');
    const canWrite= user.role === 'DUI_ADMIN';
    let elements = [];
    if (!tires.extraBrands) {
      return null;
    }
    tires.extraBrands.forEach((brand, i)=>
      elements.push(
        <li key={i} className={"d-flex"}>
          <Checkbox checked={true} disabled={true} />
          <span>{brand['name']}</span>
          {canWrite &&
          <LabelEncoder keys={['tires.brand']} labelId={brand.id} onValidate={this.onValidateExtraBrand}
                        values={{'tires.brand': brand.name}}>
            <span>
              <a className={"smaller"}>{formatMessage({id: 'action.edit'})}</a>&nbsp;
              <a className={"smaller"} onClick={(e) => {e.stopPropagation(); this.removeBrand(brand.id)}}>{formatMessage({id: 'action.delete'})}</a>
            </span>
          </LabelEncoder>}
        </li>
      )
    );
    return elements;
  };

  renderMainBrand = (item, error, canWrite) => {
    const {name} = item;
    return (
      <CheckboxItem canWrite={canWrite} onChange={(n, v) => this.onCheckboxItemChange(n, v, 'mainBrands')} name={name}
                    config={{}}  item={item} labelKey={`tires.${name}`}

      />
    )
  };

  render() {
    const {intl:{formatMessage}, loading, fetchTires, saveTires, configurationHints} = this.props;
    const {mainBrands={}} = fetchTires.tires;
    const {tires} = this.state;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';
    const canAddBrand = !tires.otherBrands || tires.otherBrands.length < MAX_TIRES_TO_ADD;

    const mainBrandsList = [];
    Object.keys(mainBrands).forEach(key => {
      mainBrandsList.push(mainBrands[key]);
    });
    mainBrandsList.sort((a, b) => a.order - b.order);

    const requiredConfig = configurationHints.includes('TIRE_BRANDS');

    const {error:{content:errors ={}} = {}} = saveTires;

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:'section.tires.title'})}
          </h2>
          {canWrite &&
            <div className="box-heading__button">
              <button onClick={this.save} disabled={loading} type="primary" className="btn btn-sm btn-primary">
                {formatMessage({id: 'action.save'})}
              </button>
            </div>
          }
        </header>
        {
          <div className="box__body">
            {requiredConfig && <div className={"alert alert--error"}>{formatMessage({id:'section.requires-configuration'}, {sectionName:formatMessage({id:'section.tires.title'})})}</div>}

            <SpinnerModal visible={loading}/>
            <div className="row">
              <div className="col-md-6 col-xxl-6">
                <ul className="list li-margin">
                  {mainBrandsList.map(t => <li key={t.name}>{this.renderMainBrand(t, errors, canWrite)}</li>)}
                </ul>
              </div>
              <div className="col-md-6 col-xxl-6">
                <ul className="list li-margin">
                  {this.renderExtraTires()}
                  {canAddBrand &&  canWrite &&
                  <li className="list__footer">
                    <LabelEncoder keys={['tires.brand']} labelId={this.state.additionalTireId} onValidate={this.onValidateExtraBrand}>
                      <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                        <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                          <use xlinkHref="#icon-plus"/>
                        </svg>
                        <strong>{formatMessage({id:'add.more'})}</strong>
                      </Button>
                    </LabelEncoder>
                  </li>}
                </ul>
                {errors && errors.tires && <div className={"txt-error"}>{formatMessage({id: errors.tires.message})}</div>}
              </div>
            </div>
          </div>
        }
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchTires: state.fetchTires,
  saveTires: state.saveTires,
  loading: state.fetchTires.loading || state.saveTires.loading,
  configurationHints: (state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints) || []
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchTires: () => dispatch({type: 'FETCH_TIRES.REQUEST'}),
  dispatchSaveTires: (tires) => dispatch({type: 'SAVE_TIRES.REQUEST', body: tires})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(Tires), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
